(() => {
if (!window.roomdenQuickBuyDelegated) {
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-rd-quick-buy-open]');
    if (!trigger) return;
    trigger.closest('rd-quick-buy')?.open();
  });
  window.roomdenQuickBuyDelegated = true;
}

const submitRoomdenQuickBuy = async ({ form, button, onSuccess }) => {
  if (!form || !button || button.getAttribute('aria-disabled') === 'true') return;

  const spinner = button.querySelector('.loading__spinner');
  const errorWrapper = form.querySelector('.product-form__error-message-wrapper');
  const errorMessage = errorWrapper?.querySelector('.product-form__error-message');
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  button.setAttribute('aria-disabled', 'true');
  button.classList.add('loading');
  spinner?.classList.remove('hidden');
  errorWrapper?.setAttribute('hidden', '');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(form);
  if (cart) {
    formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(button);
  }
  config.body = formData;

  try {
    const response = await fetch(routes.cart_add_url, config).then((result) => result.json());
    if (response.status) throw new Error(response.description || response.message || 'Unable to add this item.');

    await onSuccess?.();
    if (cart) {
      await cart.renderContents(response);
    } else {
      window.location = routes.cart_url;
    }
  } catch (error) {
    if (errorMessage) errorMessage.textContent = error.message;
    errorWrapper?.removeAttribute('hidden');
  } finally {
    button.classList.remove('loading');
    spinner?.classList.add('hidden');
    button.removeAttribute('aria-disabled');
  }
};

if (!customElements.get('rd-quick-buy-direct')) {
  customElements.define(
    'rd-quick-buy-direct',
    class RoomdenQuickBuyDirect extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => {
          if (this.initialized || !this.isConnected) return;
          this.form = this.querySelector('form');
          this.button = this.querySelector('[type="submit"]');
          this.onSubmit = (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            submitRoomdenQuickBuy({ form: this.form, button: this.button });
          };
          this.form?.addEventListener('submit', this.onSubmit, true);
          this.initialized = true;
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.form?.removeEventListener('submit', this.onSubmit, true);
        this.initialized = false;
      }
    }
  );
}

if (!customElements.get('rd-quick-buy')) {
  customElements.define(
    'rd-quick-buy',
    class RoomdenQuickBuy extends HTMLElement {
      constructor() {
        super();
        this.initialized = false;
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.onDialogClick = this.onDialogClick.bind(this);
        this.onDialogClose = this.onDialogClose.bind(this);
        this.onValueClick = this.onValueClick.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
      }

      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.initialized || !this.isConnected) return;
        this.trigger = this.querySelector('[data-rd-quick-buy-open]');
        this.dialog = this.querySelector('[data-rd-quick-buy-dialog]');
        this.closeButton = this.querySelector('[data-rd-quick-buy-close]');
        this.variantInput = this.querySelector('[data-rd-quick-buy-variant-id]');
        this.submitButton = this.querySelector('[data-rd-quick-buy-submit]');
        this.submitLabel = this.querySelector('[data-rd-quick-buy-submit-label]');
        this.price = this.querySelector('[data-rd-quick-buy-price]');
        this.status = this.querySelector('[data-rd-quick-buy-status]');
        this.image = this.querySelector('[data-rd-quick-buy-image]');
        this.form = this.querySelector('.rd-quick-buy__form form');
        this.valueButtons = [...this.querySelectorAll('[data-rd-quick-buy-value]')];
        this.variantData = JSON.parse(this.querySelector('[data-rd-quick-buy-variants]')?.textContent || '[]');
        this.selectedOptions = [];

        this.querySelectorAll('[data-rd-quick-buy-option]').forEach((group) => {
          const selected = group.querySelector('[data-rd-quick-buy-value][aria-pressed="true"]');
          this.selectedOptions[Number(group.dataset.optionIndex)] = selected?.dataset.optionValue || '';
        });
        this.trigger?.addEventListener('click', this.open);
        if (this.trigger) this.trigger.onclick = this.open;
        this.closeButton?.addEventListener('click', this.close);
        this.dialog?.addEventListener('click', this.onDialogClick);
        this.dialog?.addEventListener('close', this.onDialogClose);
        this.form?.addEventListener('submit', this.onFormSubmit, true);
        this.valueButtons.forEach((button) => button.addEventListener('click', this.onValueClick));
        this.initialized = true;
        this.updateState(false);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        if (!this.initialized) return;
        this.trigger?.removeEventListener('click', this.open);
        if (this.trigger?.onclick === this.open) this.trigger.onclick = null;
        this.closeButton?.removeEventListener('click', this.close);
        this.dialog?.removeEventListener('click', this.onDialogClick);
        this.dialog?.removeEventListener('close', this.onDialogClose);
        this.form?.removeEventListener('submit', this.onFormSubmit, true);
        this.valueButtons.forEach((button) => button.removeEventListener('click', this.onValueClick));
        this.initialized = false;
      }

      open() {
        if (!this.dialog || this.dialog.open) return;
        this.syncFromTriggerURL();
        document.body.classList.add('rd-quick-buy-is-open');
        this.dialog.showModal();
        requestAnimationFrame(() => this.dialog.classList.add('is-visible'));
        this.closeButton?.focus({ preventScroll: true });
      }

      close(returnFocus = true) {
        if (!this.dialog?.open) return;
        this.dialog.classList.remove('is-visible');
        this.dialog.close();
        if (returnFocus) this.trigger?.focus({ preventScroll: true });
      }

      onDialogClick(event) {
        if (event.target === this.dialog) this.close();
      }

      onDialogClose() {
        document.body.classList.remove('rd-quick-buy-is-open');
      }

      onValueClick(event) {
        const button = event.currentTarget;
        const optionIndex = Number(button.dataset.optionIndex);
        this.selectedOptions[optionIndex] = button.dataset.optionValue;

        this.querySelectorAll(`[data-rd-quick-buy-value][data-option-index="${optionIndex}"]`).forEach((valueButton) => {
          const selected = valueButton === button;
          valueButton.classList.toggle('is-selected', selected);
          valueButton.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        const group = button.closest('[data-rd-quick-buy-option]');
        const selectedLabel = group?.querySelector('[data-rd-quick-buy-option-value]');
        if (selectedLabel) selectedLabel.textContent = button.dataset.optionValue;

        this.updateState(true);
      }

      onFormSubmit(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const variantId = this.dataset.selectedVariantId;
        if (!variantId) return;
        const input = this.querySelector('[data-rd-quick-buy-variant-id]');
        input.defaultValue = variantId;
        input.value = variantId;
        submitRoomdenQuickBuy({
          form: this.form,
          button: this.submitButton,
          onSuccess: () => {
            this.close(false);
            return new Promise((resolve) => requestAnimationFrame(resolve));
          },
        });
      }

      syncFromTriggerURL() {
        const productUrl = this.trigger?.dataset.productUrl;
        if (!productUrl) return;

        const variantId = new URL(productUrl, window.location.origin).searchParams.get('variant');
        const variant = this.variantData.find((candidate) => String(candidate.id) === String(variantId));
        if (!variant) return;

        this.selectedOptions = [...variant.options];
        this.valueButtons.forEach((button) => {
          const optionIndex = Number(button.dataset.optionIndex);
          const selected = button.dataset.optionValue === this.selectedOptions[optionIndex];
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        this.querySelectorAll('[data-rd-quick-buy-option]').forEach((group) => {
          const label = group.querySelector('[data-rd-quick-buy-option-value]');
          if (label) label.textContent = this.selectedOptions[Number(group.dataset.optionIndex)] || '';
        });
        this.updateState(false);
      }

      updateState(announce = true) {
        this.selectedOptions = [...this.querySelectorAll('[data-rd-quick-buy-option]')].map(
          (group) => group.querySelector('[data-rd-quick-buy-value][aria-pressed="true"]')?.dataset.optionValue || ''
        );
        const variant = this.variantData.find(
          (candidate) => candidate.options.length === this.selectedOptions.length &&
            candidate.options.every((option, index) => option === this.selectedOptions[index])
        );

        this.updateOptionAvailability();

        if (!variant) {
          this.setUnavailable(window.variantStrings?.unavailable || 'Unavailable', announce);
          return;
        }

        this.variantInput = this.querySelector('[data-rd-quick-buy-variant-id]');
        this.variantInput.defaultValue = String(variant.id);
        this.variantInput.value = String(variant.id);
        this.dataset.selectedVariantId = String(variant.id);
        this.updatePrice(variant);
        this.updateImage(variant);

        if (variant.available) {
          this.submitButton.disabled = false;
          this.submitButton.removeAttribute('aria-disabled');
          this.submitLabel.textContent = window.variantStrings?.addToCart || 'Add to cart';
          if (announce) this.status.textContent = `${this.selectedOptions.join(' / ')} selected.`;
        } else {
          this.setUnavailable(window.variantStrings?.soldOut || 'Sold out', announce);
        }
      }

      updateOptionAvailability() {
        this.valueButtons.forEach((button) => {
          const optionIndex = Number(button.dataset.optionIndex);
          const possible = this.variantData.some((variant) => {
            if (!variant.available || variant.options[optionIndex] !== button.dataset.optionValue) return false;
            return variant.options.every((option, index) => index === optionIndex || option === this.selectedOptions[index]);
          });
          button.classList.toggle('is-unavailable', !possible);
          button.setAttribute('aria-disabled', possible ? 'false' : 'true');
        });
      }

      updatePrice(variant) {
        if (!this.price) return;
        this.price.innerHTML = `${variant.compareAtPrice ? `<s>${variant.compareAtPrice}</s>` : ''}<span>${variant.price}</span>`;
      }

      updateImage(variant) {
        if (!this.image || !variant.image) return;
        this.image.src = variant.image;
        this.image.removeAttribute('srcset');
      }

      setUnavailable(label, announce) {
        this.variantInput = this.querySelector('[data-rd-quick-buy-variant-id]');
        this.variantInput.defaultValue = '';
        this.variantInput.value = '';
        delete this.dataset.selectedVariantId;
        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitLabel.textContent = label;
        if (announce) this.status.textContent = `${this.selectedOptions.join(' / ')} is ${label.toLowerCase()}.`;
      }
    }
  );
}
})();
